module.exports = __webpack_public_path__ + "img/epr-article-top-img@2x.2cc729a2.webp";